<!-- attendance-status-card.component.html -->
<div class="card h-100">
  <div class="card-header d-flex justify-content-between align-items-center">
    <span>{{ title }}</span>
    @if (employees.length > 0) {
      <span class="app-badge badge-secondary">
        {{
          filteredEmployees.length !== employees.length
            ? filteredEmployees.length + ' / ' + employees.length
            : employees.length
        }}
      </span>
    }
  </div>

  <div class="card-body d-flex flex-column gap-2 p-2">
    <!-- Search box -->
    @if (employees.length > 0) {
      <div class="input-group input-group-sm">
        <span class="input-group-text bg-white border-end-0">
          <i class="bi bi-search text-muted" style="font-size: 0.75rem"></i>
        </span>
        <input type="text" class="form-control border-start-0 ps-0" placeholder="Search..." [(ngModel)]="searchQuery" />
        <button *ngIf="searchQuery" class="btn btn-outline-secondary btn-sm" type="button" (click)="searchQuery = ''">
          <i class="bi bi-x"></i>
        </button>
      </div>
    }

    <ng-container *ngIf="filteredEmployees.length; else noData">
      <ul class="list-group list-group-flush mb-0">
        <li
          *ngFor="let emp of filteredEmployees"
          class="list-group-item d-flex align-items-center px-0 py-2"
          [class.cursor-pointer]="emp.status !== PresenceStatus.YET_TO_CHECK_IN"
          (click)="onEmployeeClick(emp)">
          <img
            [src]="emp.profile_image || getDefaultProfilePicUrl(emp.first_name, emp.last_name)"
            alt="{{ emp.first_name }} {{ emp.last_name }}"
            class="rounded-circle me-2"
            style="width: 32px; height: 32px"
            (error)="handleImageError($event)" />
          <div class="flex-grow-1">
            <div class="d-flex align-items-center gap-2">
              {{ emp.first_name }} {{ emp.last_name }}
              <i *ngIf="emp.status !== PresenceStatus.YET_TO_CHECK_IN" class="bi bi-chevron-right text-muted small"></i>
            </div>
            <small class="text-muted">
              {{
                emp.status === 'yet-to-check-in'
                  ? 'Not yet checked in'
                  : emp.location + ' • ' + convertUTCtoIST(emp.time!)
              }}
            </small>
          </div>
        </li>
      </ul>
    </ng-container>

    <ng-template #noData>
      <p class="text-muted mb-0 small">
        {{ searchQuery ? 'No match found.' : emptyMessage }}
      </p>
    </ng-template>
  </div>
</div>
